const ja_abilities = {
  flm_rs      : '火属性耐性',
  wtr_rs      : '水属性耐性',
  wnd_rs      : '風属性耐性',
  lgh_rs      : '光属性耐性',
  shd_rs      : '闇属性耐性',

  afl_grd     : '状態異常無効',
  psn_rs      : '毒耐性',
  brn_rs      : '火傷耐性',
  frz_rs      : '凍結耐性',
  prl_rs      : '麻痺耐性',
  bln_rs      : '暗闇耐性',
  stn_rs      : '気絶耐性',
  crs_rs      : '呪い耐性',
  bg_rs       : 'ずぶぬれ耐性',
  slp_rs      : '睡眠耐性',

  hmd_rs      : '真・碧竜耐性',
  md_rs       : '碧竜耐性',
  hbr_rs      : '真・緋竜耐性',
  br_rs       : '緋竜耐性',
  hmr_rs      : '真・青竜耐性',
  mr_rs       : '青竜耐性',
  hjp_rs      : '真・輝竜耐性',
  jp_rs       : '輝竜耐性',
  hzd_rs      : '真・闇竜耐性',
  zd_rs       : '闇竜耐性',

  hfl_str     : 'HP満タンで攻',
  hfl_dfn     : 'HP満タンで防',
  hfl_hl      : 'HP満タンで回復',
  hfl_skl_dmg : 'HP満タンでスキル',
  hfl_crt_rt  : 'HP満タンで会心',
  hfl_crt_dmg : 'HP満タンで会心威力',

  h70_str     : 'HP70%で攻',
  h70_dfn     : 'HP70%で防',
  h70_hl      : 'HP70%で回復',
  h70_skl_dmg : 'HP70%でスキル',
  h70_crt_rt  : 'HP70%で会心',
  h70_crt_dmg : 'HP70%で会心威力',

  str_dbb     : 'プロテクトリンク・攻',
  hl_dbb      : 'プロテクトリンク・治癒',
  enr_dbb     : 'プロテクトリンク・やる気',
  crt_dmg_dbb : 'プロテクトリンク・会心威力',

  lst_ofn     : '背水の陣・攻',
  lst_dfn     : '背水の陣・防',
  lst_rcv     : '背水の陣・治癒',
  lst_crt_rt  : '背水の陣・会心',
  rsl_ofn     : '起死回生・攻',

  flr_str     : '疾風怒涛・攻',
  flr_dvs     : '疾風怒涛・会心',
  hts_elu     : 'ヒットでやる気アップ',

  drg_dmg     : '竜化中ダメージアップ',
  drg_tm      : '竜化時間',
  drg_clw     : '竜の恩寵・攻',

  skl_prp     : '開幕スキルゲージ',
  shs_prp     : '開幕竜化ゲージ',
  enr_prp     : '開幕やる気アップ',
  shl_prp     : '開幕ダメージシールド',

  skl_hst     : 'スキルブースト',
  unt_hst     : '一致団結・スキルブースト',
  stk_hst     : 'スキルブースト・強撃',
 
  frc_stk     : 'バーストダメージ',
  frc_chr     : 'スキルチャージ・強撃',

  ovd_pns     : 'オーバードライブ特効',
  brk_pns     : 'ブレイク特効',
  psn_pns     : '毒特効',
  brn_pns     : '火傷特効',
  frz_pns     : '凍結特効',
  prl_pns     : '麻痺特効',
  bln_pns     : '暗闇特効',
  stn_pns     : '気絶特効',
  crs_pns     : '呪い特効',
  bg_pns      : 'ずぶぬれ特効',
  slp_pns     : '睡眠特効',

  slyr_str    : '獅子奮迅・攻',
  stkr_str    : 'バースト撃破・攻',

  gg_acl      : 'ゲージブレイク',
  gg_inh      : 'ゲージディレイ',

  hp          : 'HP',
  skl_dmg     : 'スキルダメージ',
  crt_rt      : 'クリティカル率',
  crt_dmg     : 'クリティカルダメージ',
  rcv_ptn     : '回復スキル効果',
  bf_tm       : 'バフスキル時間',

  exp_1       : 'ハッピー星竜祭！',
  exp_2       : 'フィールマイハート',
  exp_3       : '世界を包む歌'
}
export default ja_abilities